/**
 * Swaps the add-to-cart button's label between "Add to cart" and "Add
 * subscription to cart" as the customer changes the selling_plan radio.
 * Shopify's subscription UX guidelines require the label to reflect
 * what's actually being added -- https://shopify.dev/docs/storefronts/
 * themes/pricing-payments/subscriptions/subscription-ux-guidelines.
 *
 * Scoped to the closest <form> from each fieldset rather than a
 * page-global selector, since add-to-cart-text__content is also used by
 * the quick-add modal's own button.
 */
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || target.name !== 'selling_plan') return;

  const fieldset = target.closest('.purchase-options');
  const form = target.closest('form');
  if (!fieldset || !form) return;

  const label = form.querySelector('.add-to-cart-text__content');
  if (!label) return;

  const oneTime = fieldset.getAttribute('data-add-to-cart-text');
  const subscription = fieldset.getAttribute('data-add-subscription-text');
  if (!oneTime || !subscription) return;

  label.textContent = target.value ? subscription : oneTime;
});
